import {Component, OnInit} from '@angular/core';
import {Page} from '../../../../global/util/enum/Page';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../../service/auth/auth.service';
import {ApplicationService} from '../../../service/application.service';
import {Dialog} from '../../../../global/util/Dialog';
import {Constant} from '../../../../global/util/Constant';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {InformType} from '../../../../global/util/enum/InformType';
import {CloneTool} from '../../../../global/util/CloneTool';
import {ConfirmComponent} from '../../../../shared/confirm/confirm.component';
import {Response} from '../../../../global/util/enum/Response';
import {AddEditTsaCredentialComponent} from '../add-edit-tsa-credential/add-edit-tsa-credential.component';
import {Tsacredential} from '../../../model/Tsacredential';
import {TsaCredentialService} from '../../../service/tsa-credential.service';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {Tsaprovider} from '../../../model/Tsaprovider';
import {TranslateService} from '@ngx-translate/core';
import {Pagination} from '../../../../global/util/Pagination';

@Component({
  selector: 'app-list-credential',
  templateUrl: './list-tsa-credential.component.html',
  styleUrls: ['./list-tsa-credential.component.css']
})
export class ListTsaCredentialComponent implements OnInit {

  public tsacredentials: Tsacredential[] = [];
  public page: any = {};
  public links: any = {};
  public enumPage = Page;
  public loading: boolean;
  public entityName = 'TITLE.TSA-CREDENTIALS';
  public term2Search: string;
  private tsaCredentialUrl: string;
  public tsaproviders: Tsaprovider[] = [];
  public tsaproviderSelected: Tsaprovider;
  pageNumber: any;
  pageNumbers: any[] = [];

  constructor(public tsaCredentialService: TsaCredentialService,
              public modalService: NgbModal,
              public authenticationService: AuthService,
              public applicationService: ApplicationService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
  }

  ngOnInit() {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[Constant.ZERO_INDEX].value;
    this.tsaproviders = LocalStorage.getTsaproviderExtra();
    this.tsaproviderSelected = this.tsaproviders[Constant.ZERO_INDEX];
    this.loadDefaultData();
  }

  private loadDefaultData() {
    this.loadTsacredential(Page.First);
  }

  public search() {
    this.reloadTsacredential();
  }

  public reloadTsacredential() {
    this.loadTsacredential(Page.First);
  }

  public loadTsacredential(page: Page): void {
    if (this.term2Search === undefined) {
      this.term2Search = '';
    }
    switch (page) {
      case Page.First:
        this.tsaCredentialUrl = Constant.ROOT_API_V1
          .concat('/tsaproviders/')
          .concat(String(this.tsaproviderSelected.id))
          .concat('/tsacredentials')
          .concat('?findby=')
          .concat(this.term2Search)
          .concat('&size=')
          .concat(this.pageNumber)
          .concat('&sort=id,desc');
        break;
      case Page.Previous:
        this.tsaCredentialUrl = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        this.tsaCredentialUrl = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        this.tsaCredentialUrl = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        this.tsaCredentialUrl = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.getTsacredentials(this.tsaCredentialUrl);
  }

  private getTsacredentials(url: string) {
    this.loading = true;
    this.tsaCredentialService.get(url).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.tsacredentials = next._embedded.tsacredentials;
      } else {
        this.tsacredentials = [];
      }
      this.page = next.page;
      this.links = next._links;
    }, error => {
      this.loading = false;
      this.entityName = this.translate.instant('TITLE.TSA-CREDENTIALS');
      if (HttpStatusCode.UNAUTHORIZED === error.error.status) {
        Dialog.show(InformType.Danger, this.entityName, error.error.message);
      } else {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  public openAddModal() {
    this.entityName = this.translate.instant('TITLE.TSA-CREDENTIALS');
    const modalRef = this.modalService.open(AddEditTsaCredentialComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.tsacredential = new Tsacredential();
    modalRef.componentInstance.purpose4Form = Constant.ADD;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadTsacredential(Page.Self);
        Dialog.show(InformType.Success, this.entityName);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      } else if (InformType.Warning === result) {
        Dialog.show(InformType.Warning, this.entityName, this.translate.instant('MESSAGE.CREDENTIALS-TSA-ARE-ALREADY-ON-FILE'));
      }
    });
  }

  public openEditModal(tsacredential: Tsacredential) {
    this.entityName = this.translate.instant('TITLE.TSA-CREDENTIALS');
    const tsacredential2Edit = CloneTool.do(tsacredential);
    const modalRef = this.modalService.open(AddEditTsaCredentialComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.tsacredential = tsacredential2Edit;
    modalRef.componentInstance.purpose4Form = Constant.EDIT;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadTsacredential(Page.Self);
        Dialog.show(InformType.Success, this.entityName);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      } else if (InformType.Warning === result) {
        Dialog.show(InformType.Warning, this.entityName, this.translate.instant('MESSAGE.CREDENTIALS-TSA-ARE-ALREADY-ON-FILE'));
      }
    });
  }

  public openModalDelete(tsacredential: Tsacredential) {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = this.translate.instant('TITLE.DELETE-CREDENTIALS');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.ARE-YOU-SURE-DELETE-TSA-CREDENTIALS');
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.deleteInstaller(tsacredential);
      }
    });
  }

  private deleteInstaller(tsacredential: Tsacredential) {
    this.loading = true;
    this.entityName = this.translate.instant('TITLE.TSA-CREDENTIALS');
    this.tsaCredentialService.delete(tsacredential).subscribe(() => {
      this.loading = false;
      this.loadTsacredential(Page.Self);
      Dialog.show(InformType.Success, this.entityName);
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.entityName);
    });
  }

  public getInstallerDescription(tsaproviderId: number): string {
    return this.tsaproviders.find(value => value.id === tsaproviderId).description;
  }
}
